import { Button, Kind } from '@thanx/uikit/button'
import { useStyletron } from '@thanx/uikit/theme'
import FileDownloadIcon from 'components/Icons/FileDownload'
import { RECOVERY_AI_TERMS_PATH } from 'constants/policyDoc'
import { buildTranslate } from 'locales'
import { buildRecoveryAiTermsDocument } from 'public/recoveryAiTermsDocument'
import React from 'react'
import { downloadTextFile } from 'utilities/downloadTextFile'
import Card from './index'

const t = buildTranslate('cms.settings.terms_and_policies.recovery_ai_terms')
const tLegal = buildTranslate('legal.recovery_ai_terms')

// Downloaded as HTML (not .txt/.md) so the Billing Terms / Additional Terms
// links inside the document stay clickable when a merchant opens the file.
const handleDownload = () => {
  downloadTextFile(
    buildRecoveryAiTermsDocument(),
    tLegal('download_filename'),
    'text/html'
  )
}

const RecoveryAiTermsCard: React.FC = () => {
  const [css] = useStyletron()

  return (
    <Card
      data-testid="recovery-ai-terms-card"
      title={t('title')}
      subtitle={t('description')}
      viewButtonText={t('view_button')}
      viewButtonHref={RECOVERY_AI_TERMS_PATH}
    >
      <div className="d-flex align-items-center">
        <Button kind={Kind.MINIMAL} onClick={handleDownload} className="pl-0">
          <span aria-hidden="true" className="mr-xs">
            <FileDownloadIcon />
          </span>
          {/* Styled on this inner span, not the Button itself — a Button
              className/override competes with baseui's own BaseButton
              styles unpredictably, but a plain span has nothing to compete
              with. */}
          <span className={css({ fontWeight: 400 })}>
            {tLegal('download_button')}
          </span>
        </Button>
      </div>
    </Card>
  )
}

export default RecoveryAiTermsCard
